
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Bar',
    props: {
        showRatios: {
            type: Boolean,
            default: true
        },
        team1Color: {
            type: String,
            required: true,
        },
        team2Color: {
            type: String,
            required: true,
        },
        team1Total: {
            type: Number,
            required: true,
        },
        team2Total: {
            type: Number,
            required: true,
        }
    },
    computed: {
        team1Ratio: function(): number {
            if (this.team1Total + this.team2Total == 0) return 50
            return Math.round(this.team1Total / (this.team1Total + this.team2Total) * 100)
        },
        team2Ratio: function(): number {
            if (this.team1Total + this.team2Total == 0) return 50
            return Math.round(this.team2Total / (this.team1Total + this.team2Total) * 100)
        },
        barWidth: function() {
            let ratio = this.team1Ratio;
            let clamped = Math.min(Math.max(ratio, 2), 98);
            return clamped.toString() + "%"
        },
    }
})
